"use client";

import { FC, useEffect } from "react";
import { useData } from "data/data-provider";
import RentalCarDatesRangeInput from "./RentalCarDatesRangeInput";
import RentalCarTimesRangeInput from "./RentalCarTimesRangeInput";
import { getLocationData } from "api/locations/locations";
import { LocationListingModal } from "models/LocationModal";
import toast from "react-hot-toast";
import LocationBranchInput from "./LocationBranchInput";
import DropOffBranchLocationInput from "./DropOffBranchLocationInput";

export interface RentalCarSearchFormProps {
  startTime: any;
  endTime: any;
  setStartTime: any;
  setEndTime: any;
  bookingDetails: any;
  isStartDateLocked: boolean;
  setIsStartDateLocked: (value: boolean) => void;
}

const SearchBar: FC<RentalCarSearchFormProps> = ({
  bookingDetails,
  startTime,
  endTime,
  setStartTime,
  setEndTime,
  isStartDateLocked,
  setIsStartDateLocked,
}) => {
  const {
    dropOffLocation,
    setPickupLocation,
    setDropoffLocation,
    setSearchedPickupLocation,
    setSearchedDropoffLocation,
    pickupLocation,
    setDropoffLocationType,
    setSameDropoffLocation,
    dropoffLocationType,
    setStartDate,
    setEndDate,
    setSelectedCar,
    selectedCar,
    startDate,
    setOurLocation,
    ourLocation,
  } = useData();

  useEffect(() => {
    if (selectedCar) {
      callOurLocationAPI();
    }
  }, [selectedCar]);

  const callOurLocationAPI = async () => {
    if (selectedCar) {
      try {
        const data = await getLocationData(selectedCar?.id);
        if (Array.isArray(data)) {
          setOurLocation(data as LocationListingModal[]);
        } else {
          throw new Error("Unable to fetch location data");
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to fetch locations");
        console.error("Location API error:", error);
      }
    }
  };

 const hasDropoffLocations = ourLocation.some(
    (loc) =>
      loc.active !== false &&
      (loc.location_type === "drop_off" || loc.location_type === "both")
  );

  const renderRadioBtn = () => {
    return (
      <div className=" [ nc-hero-field-padding ] flex items-center flex-wrap flex-row border-b border-secondary-100">
        <div
          className={`py-1.5 px-4 flex items-center rounded-md font-medium text-xs cursor-pointer mr-2 sm:mr-3 ${dropoffLocationType === true
              ? "bg-primary-100  border-primary-200 text-on-primary shadow-black/10 shadow-lg"
              : " text-text-color"
            }`}
          onClick={(e) => {
            setDropoffLocationType(true);
            setDropoffLocation(pickupLocation);
            setSearchedDropoffLocation(pickupLocation?.name ?? "");
            setSameDropoffLocation(true);
          }}
        >
          Same drop off
        </div>

        <div
          className={`py-1.5 px-4 flex items-center rounded-md font-medium text-xs cursor-pointer mr-2 sm:mr-3 ${dropoffLocationType === false
              ? "bg-primary-100  border-primary-200 text-on-primary shadow-black/10 shadow-lg"
              : " text-text-color"
            }`}
          onClick={() => {
            setDropoffLocationType(false);
            setSameDropoffLocation(false);
            const activeLocations = ourLocation.filter((loc) => loc.active !== false);
            if (activeLocations.length === 1) {
              setPickupLocation(activeLocations[0]);
              setDropoffLocation(activeLocations[0]);
              setSearchedPickupLocation(activeLocations[0].name ?? "");
              setSearchedDropoffLocation(activeLocations[0].name ?? "");
            }
          }}
        >
          Different drop off
        </div>

      </div>
    );
  };

  const isDdropOffdifferent = dropoffLocationType === false;

  return (
    <form className="w-full relative mt-8 rounded-md shadow-xl bg-secondary-50/80 backdrop-blur-sm z-50">
      <div className="flex flex-start ml-12"></div>
      {hasDropoffLocations && renderRadioBtn()}
      <div className={`relative flex flex-row `}>
        <LocationBranchInput
          placeHolder="Pick up Location"
          desc="Where are you going?"
          className="flex-1"
          sameDropOffLocation={dropoffLocationType === false}
          ourLocation={ourLocation}
        />
        {isDdropOffdifferent && (
          <>
            <div className="self-center border-r border-secondary-100 h-8"></div>
            <DropOffBranchLocationInput
              placeHolder="Drop off Location"
              desc="Where are you going?"
              className="flex-1"
              divHideVerticalLineClass="-inset-x-0.5"
              ourLocation={ourLocation}
            />
          </>
        )}
        <div className="self-center border-r border-secondary-100 h-8"></div>
        <RentalCarDatesRangeInput
          selectedCar={selectedCar}
          className="flex-1"
          bookingDetails={bookingDetails}
          isStartDateLocked={isStartDateLocked}
          setIsStartDateLocked={setIsStartDateLocked}
        />
        <div className="self-center border-r border-secondary-100 h-8"></div>
        <RentalCarTimesRangeInput
          startTime={startTime}
          setStartTime={setStartTime}
          endTime={endTime}
          setEndTime={setEndTime}
          className="flex-2"
          isStartDateLocked={isStartDateLocked}
        />
      </div>
    </form>
  );
};

export default SearchBar;